import HeroIconWinning from "./HeroIconWinning";
import "./hero-icon-winning.scss";

export default HeroIconWinning;
